<div class="session-timeout-page">
  <div class="session-timeout-card">
    <div class="timeout-icon" aria-hidden="true">
      <img src="/images/session-expired.png" alt="Session expired" />
    </div>
    <h1>Session Timed Out</h1>
    <p>
      Your session expired for security reasons. Please refresh to continue your admission form.
    </p>

    <div class="actions">
      <button type="button" class="btn-primary" (click)="retrySession()">
        Refresh Session
      </button>
    </div>
  </div>

  <footer class="screen-footer">
    Copyright © {{ currentYear }} Thoughtniques Technologies Pvt ltd.
  </footer>
</div>
